import { useState } from "react";
import { toast } from "sonner";
import { useAuth } from "../../context/AuthContext";
import api, { formatApiErrorDetail } from "../../lib/api";

export default function MemberProfile() {
  const { user, refresh } = useAuth();
  const [form, setForm] = useState({ name: user?.name || "", phone: user?.phone || "" });
  const [saving, setSaving] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.patch("/member/profile", { name: form.name.trim(), phone: form.phone.trim() });
      await refresh();
      toast.success("Profile saved");
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  return (
    <div className="max-w-lg space-y-8" data-testid="member-profile">
      <div>
        <div className="tracker text-brand mb-3">[ Profile ]</div>
        <h1 className="font-display text-4xl sm:text-5xl">Your details.</h1>
        <p className="text-zinc-500 mt-2">Businesses you book with see your name, email and phone so they can reach you about a class.</p>
      </div>
      <form onSubmit={save} className="card-flat p-6 space-y-4">
        <div>
          <label className="tracker block mb-2">Full name</label>
          <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full px-4 py-3 border" data-testid="member-profile-name" />
        </div>
        <div>
          <label className="tracker block mb-2">Email</label>
          <input value={user?.email || ""} disabled className="w-full px-4 py-3 border opacity-60" data-testid="member-profile-email" />
          <p className="text-[11px] text-zinc-500 mt-1.5">Your bookings and class credits are attached to this email.</p>
        </div>
        <div>
          <label className="tracker block mb-2">Phone</label>
          <input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} placeholder="+44 7700 900123" className="w-full px-4 py-3 border" data-testid="member-profile-phone" />
        </div>
        <button type="submit" disabled={saving} className="btn-primary" data-testid="member-profile-save">{saving ? "Saving…" : "Save changes"}</button>
      </form>
    </div>
  );
}
